namespace RedBullMOBILE360.Web.Models {
    export interface OSNSubscriptionRequest {
        MSISDN?: string;
        Fees?: number;
        Duration?: number;
    }
}
